import { render } from "./VoucherOrganizations.vue?vue&type=template&id=f3d5e83e&scoped=true"
import script from "./VoucherOrganizations.vue?vue&type=script&lang=js"
export * from "./VoucherOrganizations.vue?vue&type=script&lang=js"

import "./VoucherOrganizations.vue?vue&type=style&index=0&id=f3d5e83e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d5e83e"]])

export default __exports__